import { render } from "./Details.vue?vue&type=template&id=2d39a646&scoped=true"
import script from "./Details.vue?vue&type=script&lang=ts"
export * from "./Details.vue?vue&type=script&lang=ts"

import "./Details.vue?vue&type=style&index=0&id=2d39a646&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-2d39a646"

export default script